import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6c292b5a = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _3b25e759 = () => interopDefault(import('..\\pages\\errors\\index.vue' /* webpackChunkName: "pages_errors_index" */))
const _f12afca2 = () => interopDefault(import('..\\pages\\not-eligible.vue' /* webpackChunkName: "pages_not-eligible" */))
const _3f1c5d55 = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _2ca0d7dc = () => interopDefault(import('..\\pages\\terms-and-conditions.vue' /* webpackChunkName: "pages_terms-and-conditions" */))
const _f0fdc5e4 = () => interopDefault(import('..\\pages\\thank-you.vue' /* webpackChunkName: "pages_thank-you" */))
const _f246873c = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _0d4055b8 = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _397bd5c0 = () => interopDefault(import('..\\pages\\upload-documents-success.vue' /* webpackChunkName: "pages_upload-documents-success" */))
const _61c9d0e9 = () => interopDefault(import('..\\pages\\upload-documents\\success.vue' /* webpackChunkName: "pages_upload-documents_success" */))
const _06f3547f = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _67ed7cf9 = () => interopDefault(import('..\\pages\\hcp\\diagnosis-information.vue' /* webpackChunkName: "pages_hcp_diagnosis-information" */))
const _1c304a14 = () => interopDefault(import('..\\pages\\hcp\\eligibility.vue' /* webpackChunkName: "pages_hcp_eligibility" */))
const _a626bf3e = () => interopDefault(import('..\\pages\\hcp\\getting-started.vue' /* webpackChunkName: "pages_hcp_getting-started" */))
const _5b02216f = () => interopDefault(import('..\\pages\\hcp\\health-insurance-information.vue' /* webpackChunkName: "pages_hcp_health-insurance-information" */))
const _6f7d3566 = () => interopDefault(import('..\\pages\\hcp\\patient-information.vue' /* webpackChunkName: "pages_hcp_patient-information" */))
const _0849ef0e = () => interopDefault(import('..\\pages\\hcp\\pharmacy-information.vue' /* webpackChunkName: "pages_hcp_pharmacy-information" */))
const _0a4ecaaa = () => interopDefault(import('..\\pages\\hcp\\prescriber-information.vue' /* webpackChunkName: "pages_hcp_prescriber-information" */))
const _75d1dcec = () => interopDefault(import('..\\pages\\hcp\\success.vue' /* webpackChunkName: "pages_hcp_success" */))
const _790e1474 = () => interopDefault(import('..\\pages\\patient\\eligibility.vue' /* webpackChunkName: "pages_patient_eligibility" */))
const _4510009f = () => interopDefault(import('..\\pages\\patient\\health-insurance-information.vue' /* webpackChunkName: "pages_patient_health-insurance-information" */))
const _355e3e40 = () => interopDefault(import('..\\pages\\patient\\patient-authorization-success.vue' /* webpackChunkName: "pages_patient_patient-authorization-success" */))
const _72422eea = () => interopDefault(import('..\\pages\\patient\\patient-consent.vue' /* webpackChunkName: "pages_patient_patient-consent" */))
const _389a9fc6 = () => interopDefault(import('..\\pages\\patient\\patient-information.vue' /* webpackChunkName: "pages_patient_patient-information" */))
const _0b4d6818 = () => interopDefault(import('..\\pages\\patient\\patient-success.vue' /* webpackChunkName: "pages_patient_patient-success" */))
const _7fc99ddb = () => interopDefault(import('..\\pages\\patient\\prescriber-information.vue' /* webpackChunkName: "pages_patient_prescriber-information" */))
const _a980cae8 = () => interopDefault(import('..\\pages\\pharmacy\\eligibility.vue' /* webpackChunkName: "pages_pharmacy_eligibility" */))
const _c08a7ece = () => interopDefault(import('..\\pages\\pharmacy\\health-insurance-information.vue' /* webpackChunkName: "pages_pharmacy_health-insurance-information" */))
const _2fcc9e66 = () => interopDefault(import('..\\pages\\pharmacy\\ncpdp.vue' /* webpackChunkName: "pages_pharmacy_ncpdp" */))
const _29832ee3 = () => interopDefault(import('..\\pages\\pharmacy\\patient-information.vue' /* webpackChunkName: "pages_pharmacy_patient-information" */))
const _7a5b1cba = () => interopDefault(import('..\\pages\\pharmacy\\pharmacy-information.vue' /* webpackChunkName: "pages_pharmacy_pharmacy-information" */))
const _540dced9 = () => interopDefault(import('..\\pages\\pharmacy\\pharmacy-information-success.vue' /* webpackChunkName: "pages_pharmacy_pharmacy-information-success" */))
const _3ccb3d56 = () => interopDefault(import('..\\pages\\pharmacy\\prescriber-information.vue' /* webpackChunkName: "pages_pharmacy_prescriber-information" */))
const _28630d24 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _6c292b5a,
    name: "error"
  }, {
    path: "/errors",
    component: _3b25e759,
    name: "errors"
  }, {
    path: "/not-eligible",
    component: _f12afca2,
    name: "not-eligible"
  }, {
    path: "/success",
    component: _3f1c5d55,
    name: "success"
  }, {
    path: "/terms-and-conditions",
    component: _2ca0d7dc,
    name: "terms-and-conditions"
  }, {
    path: "/thank-you",
    component: _f0fdc5e4,
    name: "thank-you"
  }, {
    path: "/unlock",
    component: _f246873c,
    name: "unlock"
  }, {
    path: "/upload-documents",
    component: _0d4055b8,
    name: "upload-documents"
  }, {
    path: "/upload-documents-success",
    component: _397bd5c0,
    children: [{
      path: "",
      component: _61c9d0e9,
      name: "upload-documents-success"
    }]
  }, {
    path: "/errors/404",
    component: _06f3547f,
    name: "errors-404"
  }, {
    path: "/hcp/diagnosis-information",
    component: _67ed7cf9,
    name: "hcp-diagnosis-information"
  }, {
    path: "/hcp/eligibility",
    component: _1c304a14,
    name: "hcp-eligibility"
  }, {
    path: "/hcp/getting-started",
    component: _a626bf3e,
    name: "hcp-getting-started"
  }, {
    path: "/hcp/health-insurance-information",
    component: _5b02216f,
    name: "hcp-health-insurance-information"
  }, {
    path: "/hcp/patient-information",
    component: _6f7d3566,
    name: "hcp-patient-information"
  }, {
    path: "/hcp/pharmacy-information",
    component: _0849ef0e,
    name: "hcp-pharmacy-information"
  }, {
    path: "/hcp/prescriber-information",
    component: _0a4ecaaa,
    name: "hcp-prescriber-information"
  }, {
    path: "/hcp/success",
    component: _75d1dcec,
    name: "hcp-success"
  }, {
    path: "/patient/eligibility",
    component: _790e1474,
    name: "patient-eligibility"
  }, {
    path: "/patient/health-insurance-information",
    component: _4510009f,
    name: "patient-health-insurance-information"
  }, {
    path: "/patient/patient-authorization-success",
    component: _355e3e40,
    name: "patient-patient-authorization-success"
  }, {
    path: "/patient/patient-consent",
    component: _72422eea,
    name: "patient-patient-consent"
  }, {
    path: "/patient/patient-information",
    component: _389a9fc6,
    name: "patient-patient-information"
  }, {
    path: "/patient/patient-success",
    component: _0b4d6818,
    name: "patient-patient-success"
  }, {
    path: "/patient/prescriber-information",
    component: _7fc99ddb,
    name: "patient-prescriber-information"
  }, {
    path: "/pharmacy/eligibility",
    component: _a980cae8,
    name: "pharmacy-eligibility"
  }, {
    path: "/pharmacy/health-insurance-information",
    component: _c08a7ece,
    name: "pharmacy-health-insurance-information"
  }, {
    path: "/pharmacy/ncpdp",
    component: _2fcc9e66,
    name: "pharmacy-ncpdp"
  }, {
    path: "/pharmacy/patient-information",
    component: _29832ee3,
    name: "pharmacy-patient-information"
  }, {
    path: "/pharmacy/pharmacy-information",
    component: _7a5b1cba,
    name: "pharmacy-pharmacy-information"
  }, {
    path: "/pharmacy/pharmacy-information-success",
    component: _540dced9,
    name: "pharmacy-pharmacy-information-success"
  }, {
    path: "/pharmacy/prescriber-information",
    component: _3ccb3d56,
    name: "pharmacy-prescriber-information"
  }, {
    path: "/",
    component: _28630d24,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
